import './StickyBar.css'
import {useCabanaContext} from "./CabanaContext";
import React, {useEffect, useState} from "react";
import {Box, Typography} from "@mui/material";
import {Link} from "react-router-dom";

export default function StickyBar() {
    const { wishlist, isLoadingWishlist} = useCabanaContext();
    const [itemsToShow, setItemsToShow] = useState(6);

    useEffect(() => {
        const updateItemsToShow = () => {
            const width = window.innerWidth;
            if (width > 1200) {
                setItemsToShow(6);
            } else if (width > 991) {
                setItemsToShow(4);
            } else {
                setItemsToShow(3);
            }
        };

        updateItemsToShow(); // Set initial value
        window.addEventListener("resize", updateItemsToShow);
        return () => window.removeEventListener("resize", updateItemsToShow);
    }, []);

    // If there is no wishlist, or it is empty, do not render anything
    if (isLoadingWishlist || !wishlist?.products || wishlist.products.length === 0) return null;
    const remainingItems = wishlist.products.length - itemsToShow;

    return(
        <div className="sticky-bar">
            <div className="sticky-bar-container-title">
                <Link to={`/giftee/registry/${wishlist.list_code}`}>
                    <Typography className="title">
                            Your gift list
                    </Typography>
                </Link>
            </div>
            <div className="sticky-bar-content">
                {wishlist.products.slice(0, itemsToShow).map((product: any, index: number) => (
                    <Box key={index} className="sticky-bar-image-container ">
                        <img src={product.image_url} alt={product.title} className="sticky-bar-image" />
                    </Box>
                ))}
                {remainingItems > 0 && (
                    <div className="more-items">
                        <Typography className="remaining-items">
                            +{remainingItems}
                        </Typography>
                    </div>
                )}
            </div>
        </div>
    )
}